// Arabic translations for the 17 SEO service pages + 4 area pages.
// Only the most SEO-impactful surfaces are translated (h1, intro, metaTitle, metaDesc, eyebrow,
// whatItIs, whoItIsFor, pricing). Lists (benefits/scope/whyUs) and FAQs stay EN — this is a
// pragmatic P2 to ship Arabic SEO value without a 5,000-word translation pass.
//
// ServiceLanding.jsx and AreaLanding.jsx merge these into the EN data when lang === 'ar'.

export const AR_SERVICES = {
  "soft-fm": {
    eyebrow: "خدمات FM السوفت · الإمارات",
    h1: "خدمات إدارة المرافق السوفت في الإمارات",
    metaTitle: "خدمات FM السوفت في دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "FM متكامل سوفت — نظافة يومية، مكافحة آفات، تنسيق حدائق، إدارة نفايات وعمال خدمات للمنشآت التجارية والسكنية والصناعية في الإمارات.",
    intro: "تشمل خدمات FM السوفت كل ما يلامس المستخدم يومياً — النظافة، مكافحة الآفات، تنسيق الحدائق، إدارة النفايات والعمالة. أوريون يقدمها جميعاً تحت عقد واحد بـ SLA في دبي وأبوظبي والشارقة وعجمان.",
    whatItIs: "FM السوفت يشمل الخدمات البشرية غير الهندسية التي تحافظ على مظهر ونظافة وراحة المبنى يومياً.",
    whoItIsFor: "ملاك المباني، مديرو العقارات، اتحادات الملاك، المستأجرون التجاريون، مجموعات التجزئة، المدارس والعيادات والمنشآت اللوجستية.",
    pricing: "عقود FM السوفت في الإمارات تتراوح عادة بين 4-12 درهم للقدم المربع سنوياً حسب التكرار ونطاق العمل. أوريون يوفر زيارة موقع مجانية ورسوماً شهرية ثابتة.",
  },
  "hard-fm": {
    eyebrow: "FM الهارد · الإمارات",
    h1: "خدمات إدارة المرافق الهارد و MEP في الإمارات",
    metaTitle: "خدمات FM الهارد الإمارات | تكييف، MEP، كهرباء وسباكة | أوريون",
    metaDesc: "FM هارد بـ SLA — تكييف، MEP، كهرباء، سباكة، حريق وسلامة. PPM في دبي وأبوظبي والشارقة وعجمان. استجابة طوارئ 24/7.",
    intro: "FM الهارد يحافظ على أنظمة المبنى الهندسية الحرجة — تكييف، MEP، كهرباء، سباكة، حريق وسلامة. فنيو أوريون المعتمدون يقدمون صيانة وقائية واستجابة طوارئ وامتثالاً تحت SLA.",
    whatItIs: "FM الهارد يشمل الخدمات الهندسية التي تحافظ على البنية التحتية الفيزيائية للمبنى — أنظمة لا يراها المستخدم لكنه يعتمد عليها.",
    whoItIsFor: "ملاك الأصول، مديرو العقارات، شركات الخدمات اللوجستية والمستأجرون التجاريون الذين يحتاجون استمرارية تشغيل ومصاريف شهرية متوقعة.",
    pricing: "عقود FM الهارد تتراوح بين 6-18 درهم للقدم المربع سنوياً حسب عمر الأصول وتعقيد الأنظمة. أوريون يقدم مقارنة مرجعية مجانية.",
  },
  "deep-cleaning-uae": {
    eyebrow: "تنظيف عميق · الإمارات",
    h1: "خدمات التنظيف العميق الاحترافي في الإمارات",
    metaTitle: "خدمات التنظيف العميق دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "تنظيف عميق لمرة واحدة وربعي وما بعد الفعاليات للفلل والشقق والمكاتب والمطابخ والمستودعات. فرق مرخصة من بلدية دبي ومواد صديقة للبيئة.",
    intro: "التنظيف العميق أكثر من نظافة عادية — هو إعادة ضبط كاملة لمساحتك بمعدات متخصصة ومواد كيميائية معتمدة. أوريون ينظف الفلل والشقق والمكاتب والمطاعم والمستودعات في الإمارات.",
    whatItIs: "التنظيف العميق هو عملية تنظيف شاملة ومكثفة تستهدف الأوساخ المتراكمة والمناطق الصعبة الوصول.",
    whoItIsFor: "أصحاب المنازل عند الانتقال، الملاك بين المستأجرين، المطاعم لتدقيق HACCP، المكاتب بعد التجديد وأي مشغل يستعد لتفتيش مهم.",
    pricing: "أسعار التنظيف العميق في الإمارات تبدأ من 350 درهم للاستوديو، 800 للغرفتين، 1,500+ للفلل و 3 دراهم للقدم المربع للأماكن التجارية.",
  },
  "hvac-maintenance-uae": {
    eyebrow: "صيانة التكييف · الإمارات",
    h1: "صيانة التكييف وخدمة المكيفات في الإمارات",
    metaTitle: "صيانة تكييف الإمارات | خدمة مكيفات دبي وأبوظبي | أوريون",
    metaDesc: "صيانة ربعية للمكيفات، PPM للمبردات، تنظيف القنوات وإعادة شحن الغاز في الإمارات. مهندسون معتمدون من DEWA وعقود AMC متاحة.",
    intro: "صيف الإمارات يصل إلى 50 درجة — لا تتحمل تعطل التكييف. أوريون يوفر صيانة وقائية للمكيفات، PPM للمبردات، تنظيف القنوات وشحن غاز طارئ.",
    whatItIs: "صيانة التكييف تشمل تنظيف وفحص ومعايرة وإصلاح جميع أنظمة التكييف — مكيفات الاسبليت، المبردات المركزية، FCU و AHU.",
    whoItIsFor: "أصحاب المنازل، مديرو العقارات، الملاك، المستأجرون التجاريون والمستودعات الذين لا يستطيعون تحمل تعطل التكييف صيفاً.",
    pricing: "صيانة المكيفات السكنية تبدأ من 99 درهم للوحدة. خطط AMC السنوية للفلل تبدأ من 1,200 درهم.",
  },
  "plumbing-services-uae": {
    eyebrow: "خدمات السباكة · الإمارات",
    h1: "خدمات السباكة الاحترافية في الإمارات",
    metaTitle: "خدمات السباكة دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "سباكة طارئة، كشف تسريبات، صرف صحي وتنظيف خزانات في الإمارات. سباكون مرخصون، نفس اليوم، طوارئ 24/7.",
    intro: "من حنفية تقطر إلى أنبوب منفجر، سباكو أوريون المرخصون يتعاملون مع كل احتياجات السباكة في الإمارات — نفس اليوم، طوارئ 24/7، أسعار ثابتة.",
    whatItIs: "خدمات السباكة تغطي تركيب وإصلاح وصيانة إمدادات المياه والصرف الصحي والتركيبات الصحية وأنظمة تسخين المياه.",
    whoItIsFor: "أصحاب المنازل، المستأجرون، الملاك، مديرو المباني، المطاعم والفنادق وأي عقار يواجه مشكلة سباكة.",
    pricing: "إصلاحات سباكة بسيطة تبدأ من 150 درهم زيارة + قطع غيار. تنظيف الصرف من 250 درهم. تنظيف خزانات المياه 350-800 درهم.",
  },
  "electrical-services-uae": {
    eyebrow: "خدمات كهربائية · الإمارات",
    h1: "خدمات كهربائية مرخصة في الإمارات",
    metaTitle: "خدمات كهربائية دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "أعمال كهربائية مرخصة من DEWA، توصيلات التشطيب، كشف الأعطال وإصلاحات طارئة في دبي وأبوظبي والشارقة وعجمان.",
    intro: "أسلاك خاطئة، قواطع متعثرة، طوارئ انقطاع — كهربائيو أوريون المرخصون من DEWA و ADDC و SEWA يتعاملون مع الأعمال الكهربائية السكنية والتجارية.",
    whatItIs: "الخدمات الكهربائية تشمل تصميم وتركيب واختبار وإصلاح وصيانة جميع أنظمة الطاقة والإضاءة في أي مبنى.",
    whoItIsFor: "أصحاب المنازل، مقاولو التشطيب، مديرو المباني، سلاسل التجزئة، المطاعم وأي عميل يحتاج عملاً كهربائياً مرخصاً.",
    pricing: "إصلاحات كهربائية بسيطة من 150 درهم زيارة. تركيب إضاءة 80-200 درهم لكل نقطة.",
  },
  "handyman-services-uae": {
    eyebrow: "خدمات الفني الشامل · الإمارات",
    h1: "خدمات الفني الشامل عند الطلب في الإمارات",
    metaTitle: "خدمات فني شامل دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "دهان، نجارة، تركيب، إصلاحات وأعمال صغيرة عبر فنيي أوريون المعتمدين. حجز نفس اليوم في الإمارات.",
    intro: "الرف الذي لم تعلقه، الباب الذي لا يغلق، الجدار الذي يحتاج لمسة — فنيو أوريون يتعاملون مع الأعمال الصغيرة في الإمارات بحجز نفس اليوم وأسعار ثابتة.",
    whatItIs: "خدمات الفني الشامل تغطي مجموعة واسعة من أعمال الصيانة الصغيرة — لمسات دهان، نجارة، تركيب، إصلاحات وتجميع.",
    whoItIsFor: "أصحاب المنازل، المستأجرون، الملاك، ومديرو المكاتب الذين يحتاجون إصلاحات سريعة بدون حجز عدة مقاولين.",
    pricing: "خدمة الفني الشامل بالساعة تبدأ من 120 درهم/ساعة بحد أدنى ساعتين. معظم المهام (3-5 مهام) تنتهي في أقل من 3 ساعات.",
  },
  "snagging-services-uae": {
    eyebrow: "خدمات Snagging · الإمارات",
    h1: "فحص العقار والتسليم في الإمارات",
    metaTitle: "خدمات فحص العقارات دبي والإمارات | أوريون",
    metaDesc: "فحص مستقل للفلل والشقق الجديدة في دبي وأبوظبي والشارقة. تقارير مفصلة خلال 48 ساعة.",
    intro: "لا تقبل التسليم قبل فحص العيوب. مفتشو أوريون المستقلون يفحصون كل سطح وتركيبة ونظام في منزلك الجديد ويقدمون تقريراً جاهزاً للمطور خلال 48 ساعة.",
    whatItIs: "الفحص هو فحص مهني لعقار حديث البناء لتحديد العيوب وأعمال التشطيب الناقصة قبل توقيع وثائق التسليم.",
    whoItIsFor: "المشترون لأول مرة، المستثمرون، مديرو العقارات والعملاء المؤسسيون الذين يقبلون التسليم من المطورين.",
    pricing: "استوديو/غرفة: 800 درهم. غرفتان: 1,000. ثلاث غرف: 1,300. فلل من 1,800 درهم. إعادة الفحص بنصف الرسوم.",
  },
  "airbnb-management-uae": {
    eyebrow: "إدارة Airbnb · الإمارات",
    h1: "إدارة Airbnb والمنازل لقصيرة الأجل في الإمارات",
    metaTitle: "إدارة Airbnb والمنازل لقصيرة الأجل دبي والإمارات | أوريون",
    metaDesc: "إدارة شاملة لـ Airbnb والإيجار قصير الأجل — تنظيف بين الضيوف، أغطية فندقية، صيانة ودعم في دبي وأبوظبي والشارقة.",
    intro: "تستضيف على Airbnb في دبي؟ أوريون يدير الجانب التشغيلي بالكامل — تنظيف نفس اليوم، أغطية جديدة، صيانة ومعايير 5 نجوم.",
    whatItIs: "إدارة Airbnb / المنازل قصيرة الأجل خدمة بمستوى الضيافة تتعامل مع التنظيف والأغطية والتجديد والصيانة بين كل حجز.",
    whoItIsFor: "مضيفون مرخصون من DTCM، مستثمرون لديهم وحدات إيجار قصير، وشركات تدير شققاً مفروشة في دبي والشارقة وأبوظبي.",
    pricing: "تنظيف استوديو 120 درهم، غرفة 160، غرفتان 220، فيلا 350+. خدمة الأغطية بالكيلو أو حسب السرير.",
  },
  "move-in-move-out-cleaning": {
    eyebrow: "تنظيف الانتقال · الإمارات",
    h1: "خدمات تنظيف الانتقال (دخول/خروج) في الإمارات",
    metaTitle: "تنظيف انتقال دبي والإمارات | أوريون",
    metaDesc: "تنظيف الانتقال بضمان استرداد الوديعة، إعادة ضبط الدخول وتسليم المالك في دبي وأبوظبي والشارقة وعجمان.",
    intro: "تنتقل من أو إلى عقار في الإمارات؟ احصل على وديعتك أو ادخل منزلاً تم إعادة ضبطه. تنظيف انتقال أوريون مبني على قوائم تسليم المالك ومواد معتمدة.",
    whatItIs: "تنظيف الانتقال هو تنظيف شامل لنهاية الإيجار مصمم لتلبية معايير تسليم المالك أو تجهيز عقار جديد للسكان.",
    whoItIsFor: "المستأجرون المغادرون لاسترداد الوديعة، المستأجرون الجدد، الملاك ومديرو العقارات الذين يجهزون الوحدات.",
    pricing: "استوديو 350 درهم، غرفة 550، غرفتان 750، ثلاث غرف 950، فلل من 1,500 درهم.",
  },
  "office-cleaning-uae": {
    eyebrow: "تنظيف المكاتب · الإمارات",
    h1: "خدمات تنظيف المكاتب الاحترافية في الإمارات",
    metaTitle: "تنظيف مكاتب دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "تنظيف يومي وأسبوعي وليلي للمكاتب في دبي وأبوظبي والشارقة وعجمان. فرق بزة موحدة، مدربة، مرخصة من البلدية.",
    intro: "مكتبك هو الانطباع الأول لعملائك والبيئة اليومية لفريقك. أوريون يقدم تنظيفاً يومياً وأسبوعياً ولياً للمكاتب في الإمارات.",
    whatItIs: "تنظيف المكاتب خدمة نظافة متكررة تغطي محطات العمل وغرف الاجتماعات والمطابخ ودورات المياه — عادة خارج ساعات العمل.",
    whoItIsFor: "مديرو المكاتب، فرق الموارد البشرية، مقاولو التشطيب، مشغلو الفضاءات المشتركة والشركات الصغيرة.",
    pricing: "تنظيف المكاتب يتراوح بين 3-8 دراهم للقدم المربع سنوياً للخدمة اليومية. الشركات الصغيرة من 1,200 درهم/شهر للخدمة الأسبوعية.",
  },
  "villa-maintenance-uae": {
    eyebrow: "صيانة الفلل · الإمارات",
    h1: "صيانة الفلل وخدمات AMC في الإمارات",
    metaTitle: "صيانة فلل دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "AMC شامل للفلل — تكييف، سباكة، كهرباء، نجارة، دهان وفني شامل تحت عقد سنوي واحد في الإمارات.",
    intro: "فيلتك أكبر أصولك — لا تدع المشاكل الصغيرة تصبح فواتير كبيرة. AMC أوريون يجمع التكييف والسباكة والكهرباء والنجارة في عقد سنوي واحد.",
    whatItIs: "AMC الفيلا هو خطة صيانة سنوية شاملة تغطي الصيانة الوقائية والاستجابات الطارئة والإصلاحات الروتينية لمنزلك.",
    whoItIsFor: "ملاك الفلل والمستأجرون طويلو الأجل في دبي وأبوظبي والشارقة وعجمان الذين يريدون تكاليف صيانة متوقعة ورقماً واحداً للاتصال.",
    pricing: "AMC لفيلا 3 غرف من 3,500 درهم/سنة. 4 غرف من 4,500. 5 غرف من 5,500.",
  },
  "annual-maintenance-contract": {
    eyebrow: "AMC · الإمارات",
    h1: "عقود الصيانة السنوية (AMC) في الإمارات",
    metaTitle: "عقد صيانة سنوية الإمارات | خطط AMC دبي | أوريون",
    metaDesc: "عقود صيانة سنوية للفلل والمكاتب والتجزئة والمستودعات في الإمارات. استجابة SLA، رسوم ثابتة شهرية، طوارئ 24/7.",
    intro: "AMC يحول تكاليف الصيانة غير المتوقعة إلى رسم شهري ثابت مع أوقات استجابة مدعومة بـ SLA. أوريون يقدم AMC للفلل والمكاتب وتجار التجزئة والمستودعات.",
    whatItIs: "عقد الصيانة السنوية اتفاقية لـ 12 شهراً تجمع الصيانة الوقائية والاستجابات الطارئة وإدارة الحساب والتقارير في رسم دوري ثابت.",
    whoItIsFor: "ملاك الفلل، مستأجرو المكاتب، سلاسل التجزئة، مشغلو المستودعات وأي كيان يريد OPEX متوقعاً وشريكاً واحداً مسؤولاً.",
    pricing: "AMC فيلا من 3,500 درهم/سنة. AMC مكتب من 8,000 درهم/سنة. AMC منفذ تجزئة من 12,000 درهم/سنة.",
  },
  "post-construction-cleaning": {
    eyebrow: "تنظيف ما بعد البناء · الإمارات",
    h1: "تنظيف ما بعد البناء والتسليم في الإمارات",
    metaTitle: "تنظيف ما بعد البناء دبي والإمارات | أوريون",
    metaDesc: "تنظيف المقاول، تنظيف لامع وتنظيف نهائي للفلل والشقق والمكاتب الجديدة في الإمارات.",
    intro: "غبار البناء ينتشر في كل مكان — والعملاء لن يوقعوا التسليم حتى يختفي. أوريون يقدم تنظيف المقاول والتنظيف اللامع والتسليم النهائي.",
    whatItIs: "تنظيف ما بعد البناء عملية ثلاث مراحل — تنظيف خشن وتنظيف المقاول وتنظيف لامع — لإزالة الغبار والدهان واللاصق والأنقاض.",
    whoItIsFor: "المطورون، مقاولو التشطيب، مصممو الديكور، ملاك العقارات ومديرو المشاريع المسؤولون عن تسليم المساحات الجديدة.",
    pricing: "استوديو 800 درهم، غرفة 1,200، غرفتان 1,800، فيلا 3,500+. التشطيب التجاري من 5 دراهم للقدم المربع.",
  },
  "pest-control-uae": {
    eyebrow: "مكافحة الآفات · الإمارات",
    h1: "خدمات مكافحة الآفات الاحترافية في الإمارات",
    metaTitle: "مكافحة آفات دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "مكافحة آفات معتمدة من البلدية للصراصير وبق الفراش والنمل الأبيض والقوارض في الإمارات. سكني وتجاري.",
    intro: "صراصير، بق فراش، نمل أبيض، قوارض — حرارة الإمارات ورطوبتها جنة الآفات. أوريون يقدم مكافحة معتمدة من البلدية للمنازل والمطاعم.",
    whatItIs: "مكافحة الآفات هي الوقاية والكشف والقضاء على الآفات باستخدام تقنيات كيميائية وميكانيكية وإدارة متكاملة (IPM).",
    whoItIsFor: "أصحاب المنازل، المستأجرون، المطاعم (تدقيق HACCP)، المكاتب، المستودعات، المدارس والعيادات.",
    pricing: "مكافحة الآفات العامة (الشقق) 200-400 درهم. علاج بق الفراش 400-1,000 درهم. حاجز النمل الأبيض 800-2,500 درهم.",
  },
  "disinfection-services-uae": {
    eyebrow: "خدمات التعقيم · الإمارات",
    h1: "خدمات التعقيم والتطهير الاحترافية في الإمارات",
    metaTitle: "خدمات تعقيم دبي وأبوظبي والإمارات | أوريون",
    metaDesc: "تعقيم بمستوى المستشفيات للمكاتب والمدارس والعيادات والتجزئة والمنازل في الإمارات. ضباب ULV، تعقيم أسطح، مواد معتمدة.",
    intro: "عندما تحتاج التأكيد — بعد المرض، قبل حدث مهم، أو كتحكم روتيني في العدوى — أوريون يقدم تعقيماً بمستوى المستشفيات باستخدام ULV.",
    whatItIs: "التعقيم هو تطبيق عوامل كيميائية أو فيزيائية على الأسطح والهواء لتدمير الفيروسات والبكتيريا والفطريات.",
    whoItIsFor: "العيادات، المدارس (KHDA/ADEK)، المكاتب بعد المرض، المطاعم لتدقيق HACCP، المنازل ذات السكان الحساسين.",
    pricing: "استوديو 250 درهم، غرفة 400، غرفتان 600، فيلا 1,200+. المكاتب والتجاري 1.5-3 درهم للقدم المربع.",
  },
};

export const AR_AREAS = {
  dubai: {
    name: "دبي",
    nameLong: "دبي، الإمارات",
    metaTitle: "إدارة المرافق وخدمات التنظيف في دبي | أوريون",
    metaDesc: "FM متكامل، تنظيف، صيانة وخدمات AMC في كل دبي — الخليج التجاري، وسط المدينة، JLT، المارينا، JAFZA و DIP.",
    intro: "أوريون يقدم إدارة مرافق وتنظيف وصيانة وخدمات AMC في كل دبي — من أبراج Grade-A في الخليج التجاري إلى مستودعات JAFZA إلى فلل المرابع العربية.",
  },
  "abu-dhabi": {
    name: "أبوظبي",
    nameLong: "أبوظبي، الإمارات",
    metaTitle: "إدارة المرافق وخدمات التنظيف في أبوظبي | أوريون",
    metaDesc: "FM متكامل، تنظيف، صيانة وخدمات AMC في كل أبوظبي — الكورنيش، الريم، السعديات، ياس، KIZAD ومصفح.",
    intro: "أوريون يخدم مشغلي أبوظبي التجاريين والسكنيين والصناعيين — من مستودعات KIZAD إلى أبراج ADGM إلى فلل السعديات.",
  },
  sharjah: {
    name: "الشارقة",
    nameLong: "الشارقة، الإمارات",
    metaTitle: "إدارة المرافق وخدمات التنظيف في الشارقة | أوريون",
    metaDesc: "FM متكامل، تنظيف، صيانة وخدمات AMC في كل الشارقة — المناطق الصناعية، المجاز، الخان، منطقة SAIF والحمرية.",
    intro: "أوريون يخدم العمود الصناعي للشارقة — منطقة SAIF، الحمرية، المناطق الصناعية 1-18 — بالإضافة إلى مواقع سكنية وتجارية.",
  },
  ajman: {
    name: "عجمان",
    nameLong: "عجمان، الإمارات",
    metaTitle: "إدارة المرافق وخدمات التنظيف في عجمان | أوريون",
    metaDesc: "FM متكامل، تنظيف، صيانة وخدمات AMC في كل عجمان — منطقة عجمان الحرة، الصناعية الجديدة، النعيمية والكورنيش.",
    intro: "مقر أوريون في منطقة عجمان الحرة، ولدينا جذور محلية عميقة في عجمان — نخدم شركات المناطق الحرة والصناعية والمباني السكنية.",
  },
};
